<template>
  <div>
    板块：
    <el-button
      class="category"
      :disabled="currentCategoryId === ''"
      @click="goToHomePage"
      :type="currentCategoryId === '' ? 'primary' : ''"
    >
      全部话题
    </el-button>
    <el-button
      v-for="(category, index) in structuredCategories"
      v-bind:key="index"
      class="category"
      :disabled="currentCategoryId === category.id"
      :type="currentCategoryId === category.id ? 'primary' : ''"
      @click="goToCategory(category.id)"
    >
      {{ category.name }}
    </el-button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "HomeCategories",
  data: function() {
    return {
      categoryId: ""
    };
  },
  props: {
    link: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState(["structuredCategories", "currentCategoryId"])
  },
  methods: {
    redirectToUrl: function(url) {
      if (this.link.startsWith(window.location.origin)) {
        this.$router.push("/" + url);
      } else {
        window.location.href = this.link + url;
      }
    },
    goToHomePage: function() {
      // window.open(this.link)
      this.redirectToUrl("");
    },
    goToCategory: function(index) {
      let url = "categories/" + index;
      this.redirectToUrl(url);
    }
  }
};
</script>
